import { render, staticRenderFns } from "./VerificationDialogSidebar.vue?vue&type=template&id=70ef9892&"
import script from "./VerificationDialogSidebar.vue?vue&type=script&lang=js&"
export * from "./VerificationDialogSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports